import React from 'react'
import './App.css'
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom'
import GameRoute from './GameRoute'
import HomeRoute from './HomeRoute'
import { DndProvider } from 'react-dnd'
import { TouchBackend } from 'react-dnd-touch-backend'
import { Auth0Provider } from "@auth0/auth0-react"

function App() {
  return (
    <DndProvider backend={TouchBackend} options={{ enableMouseEvents: true }}>
      <Auth0Provider domain={process.env.REACT_APP_AUTH0_DOMAIN || ""} clientId={process.env.REACT_APP_AUTH0_CLIENT_ID || ""} redirectUri={window.location.origin}>
        <div className="App">
          <Router>
            <Switch>
              <Route exact path="/" component={HomeRoute} />
              <Route path="/g/:gameId" component={GameRoute} />
              <Redirect to="/" />
            </Switch>
          </Router>
        </div>
      </Auth0Provider>
    </DndProvider>
  );
}

export default App;
